/* Typende placeholder in de zoekbalk (DIEK, okt 2026): "Zoek naar tuinslangen|" → wist → volgende term.
   Termen en voorvoegsel komen uit data-attributen (sectie-instellingen). Stopt bij focus of ingevulde tekst,
   pauzeert als het tabblad verborgen is, en staat stil bij prefers-reduced-motion (dan één vaste term). */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(input) {
    var terms = (input.dataset.typewriterTerms || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!terms.length) return;
    var prefix = (input.dataset.typewriterPrefix || '').trim();
    var base = prefix ? prefix + ' ' : '';
    var staticPlaceholder = input.getAttribute('placeholder') || '';
    if (reduceMotion) { input.placeholder = base + terms[0]; return; }

    var termIndex = 0, charIndex = 0, deleting = false, timer = null, running = false;
    function schedule(ms) { timer = setTimeout(tick, ms); }
    function tick() {
      if (!running) return;
      var term = terms[termIndex];
      if (!deleting) {
        charIndex++;
        input.placeholder = base + term.slice(0, charIndex);
        if (charIndex >= term.length) { deleting = true; return schedule(1700); }
        return schedule(60 + Math.random() * 60);
      }
      charIndex--;
      input.placeholder = base + term.slice(0, charIndex);
      if (charIndex <= 0) { deleting = false; termIndex = (termIndex + 1) % terms.length; return schedule(500); }
      schedule(30);
    }
    function start() { if (running || input.value) return; running = true; tick(); }
    function stop(toStatic) { running = false; clearTimeout(timer); if (toStatic) input.placeholder = staticPlaceholder; }

    input.addEventListener('focus', function () { stop(true); });
    input.addEventListener('blur', function () { if (!input.value) { charIndex = 0; deleting = false; start(); } });
    input.addEventListener('input', function () { if (input.value) stop(false); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(false);
      else if (document.activeElement !== input) start();
    });
    start();
  }

  function boot() {
    document.querySelectorAll('input[data-typewriter-terms]').forEach(function (input) {
      if (input.dataset.typewriterReady) return;
      input.dataset.typewriterReady = 'true';
      init(input);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
